import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActiveCartService } from '@cart/data-access';
import { CheckoutService } from '@checkout-v2/feature';
import { CityService } from '@city/feature';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import { combineLatest, filter } from 'rxjs';
import { CheckoutHeaderComponent } from '../../components/checkout-header';
import { CheckoutOrderSummaryComponent } from '../../components/checkout-order-summary';
import { ContactsComponent } from '../../components/contacts';
import { PaymentModesComponent } from '../../components/payment-modes';
import { ReceiptComponent } from '../../components/receipt/receipt.component';
import { SwitchProfileComponent } from '../../components/switch-profile';

@Component({
  selector: 'sd-checkout-page',
  imports: [
    CheckoutHeaderComponent,
    SdHeadingComponent,
    SwitchProfileComponent,
    ReceiptComponent,
    PaymentModesComponent,
    ContactsComponent,
    CheckoutOrderSummaryComponent,
  ],
  templateUrl: './checkout-page.component.html',
  styleUrl: './checkout-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutPageComponent implements OnInit, OnDestroy {
  private readonly checkoutService = inject(CheckoutService);
  private readonly activeCartService = inject(ActiveCartService);
  private readonly cityService = inject(CityService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    combineLatest({
      activeCartId: this.activeCartService.getActiveCartId(),
      activeBaseStoreCode: this.cityService.activeBaseStoreCode$,
    })
      .pipe(
        filter(({ activeCartId, activeBaseStoreCode }) => !!activeCartId && !!activeBaseStoreCode),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.checkoutService.init();
      });
  }

  ngOnDestroy(): void {
    this.checkoutService.destroy();
  }
}
